import React, { useCallback, useEffect } from "react";

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { Colors } from "../palettes/colorPalette";
import { CostMarker } from "./TierMarker";
import { GameClient } from "../gameClient";

declare var gameClient: GameClient;

const containerStyleLeft = css`
    width: 12vw;
    position: absolute;
    top: 50%;
    left: 3%;
    transform: translate(0, -50%);
    padding: 3% 2.5%;
    font-family: NotoSans;
    border-radius: 1vw;
    color: white;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;

    &:hover {
        background: rgba(255, 255, 255, 0.7);
        color: black;
    }
`;

const containerStyleRight = css`
    position: absolute;
    top: 50%;
    right: 3%;
    transform: translate(0, -50%);
    padding: 3% 2.5%;
    font-family: NotoSans;
    border-radius: 1vw;
    color: white;
    display: flex;
    justify-content: center;
    width: 12vw;
    background: rgba(0, 0, 0, 0.5);
    align-items: center;

    &:hover {
        background: rgba(255, 255, 255, 0.7);
        color: black;
    }
`;

const textStyle = css`
    text-align:center;
`;

const circleStyle = css`
  width: 27px;
  filter: drop-shadow(2px 4px 2px ${Colors.UICarbShadow})
`;

export const SellInfo = ({
    isPreview = false,
}) => {
    const mouseUp = useCallback((e) => {
        gameClient.sellImmuneCell();
    }, []);
    if (isPreview) {
        return (
            <>
                <div id='uiinfo' css={containerStyleLeft} >
                    <span css={textStyle}>Drop here to cancel</span>
                </div>
                <div id='uiinfo' css={containerStyleRight}>
                    <span css={textStyle}>Drop here to cancel</span>
                </div>
            </>
        )
    }

    return (
        <>
            <div id='uiinfo' css={containerStyleLeft} onMouseUp={mouseUp}>
                <span css={textStyle}>Drop here to sell for<br /></span>
                <CostMarker cost={1} position='inline' />
            </div>
            <div id='uiinfo' css={containerStyleRight} onMouseUp={mouseUp}>
                <span css={textStyle}>Drop here to sell for<br /></span>
                <CostMarker cost={1} position='inline' />
            </div>
        </>
    )
};
